// extracted by mini-css-extract-plugin
export default {"title":"Faq-module__title--vHIHQ"};